import { Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TileWrapper = styled(Paper)(({ theme }) => ({
  borderRadius: 15,
  [theme.breakpoints.up('md')]: {
    width: 360,
  },
  padding: theme.spacing(2),
}));

export const ImageWrapper = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  img: {
    objectFit: 'contain',
    height: '100%',
  },
}));

export const TileVoice = styled(Typography)(({ theme }) => ({
  fontStyle: 'normal',
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(2),
}));

export const LogoWrapper = styled('div')(() => ({
  flexDirection: 'start',
  height: 40,
  width: '100%',
  position: 'relative',

  img: {
    objectFit: 'contain',
    objectPosition: 'left',
  },
}));
